import PropTypes from 'prop-types'
import React, { useLayoutEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Modal } from 'semantic-ui-react'
import { Loader } from 'shared/components/Loader'
import { images } from 'packages/simplesat-config'
import { TooltipLabel } from 'components/TooltipLabel'
import constants from 'config/constants'

const ImageSection = styled.div`
  align-items: center;
  display: flex !important;
  justify-content: center;
  min-height: 240px;
`

const TextDescription = styled.div`
  font-weight: normal;
`

export default function ChooseSurveyTypeModalV2({
  handleClose,
  handleOnSelectCSAT,
  handleOnSelectNPS,
  handleOnSelectCES,
  handleOnSelectFiveStar,
  isOpenModal,
  isLoading,
}) {
  /** @type {React.MutableRefObject<HTMLAnchorElement>} */
  const cardRef = useRef(null)
  const [cardWidth, setCardWidth] = useState(null)
  useLayoutEffect(() => {
    if (isOpenModal) {
      const cardWidth = cardRef.current.clientWidth
      setCardWidth(cardWidth)
    }
  }, [isOpenModal])
  return (
    <Modal className="large coupled new-survey first" open={isOpenModal} onClose={handleClose}>
      <Modal.Header>
        <TooltipLabel
          label="Choose a metric for the primary question"
          descriptionTitle="Primary question"
          descriptionContent={
            <React.Fragment>
              <p>
                The first question of a survey is connected with a customer satisfaction metric,
                such as CSAT or NPS.
              </p>
              <p>
                This question and metric is used to calculate the survey’s main stats, leaderboards,
                and drive notifications.
              </p>
            </React.Fragment>
          }
          learnMoreLink="https://help.simplesat.io/surveys/survey-metrics-explained"
        />
      </Modal.Header>
      <Modal.Content>
        <div className="pt-4 md:pt-0">
          <div className="ui four cards stackable">
            {isLoading && (
              <div style={{ zIndex: 10 }}>
                <Loader />
              </div>
            )}
            <a
              ref={cardRef}
              data-testid="template-card-csat"
              className="ui card"
              onClick={handleOnSelectCSAT}
            >
              <ImageSection className="image">
                <img
                  className="ui centered image"
                  alt="CSAT-type"
                  style={{ width: cardWidth }}
                  srcSet={`${images.csatTypeBoxImg}?size=${cardWidth}, ${
                    images.csatTypeBoxImg
                  }?size=${cardWidth * 2} 2x`}
                />
              </ImageSection>
              <div className="content">
                <div className="header">{constants.questionMetricTitle.CSAT}</div>
                <TextDescription className="description">
                  Capture a customer's satisfaction for a specific interaction, ticket, or project.
                </TextDescription>
              </div>
            </a>
            <a data-testid="template-card-nps" className="ui card" onClick={handleOnSelectNPS}>
              <ImageSection className="image">
                <img
                  className="ui centered image"
                  alt="email-type"
                  style={{ width: cardWidth }}
                  srcSet={`${images.npsTypeBoxImg}?size=${cardWidth}, ${
                    images.npsTypeBoxImg
                  }?size=${cardWidth * 2} 2x`}
                />
              </ImageSection>
              <div className="content">
                <div className="header">{constants.questionMetricTitle.NPS}&nbsp;</div>
                <TextDescription className="description">
                  Measure customer loyalty to predict long term happiness.
                </TextDescription>
              </div>
            </a>
            <a data-testid="template-card-ces" className="ui card" onClick={handleOnSelectCES}>
              <ImageSection className="image">
                <img
                  className="ui centered image"
                  alt="email-type"
                  style={{ width: cardWidth }}
                  srcSet={`${images.cesTypeBoxImg}?size=${cardWidth}, ${
                    images.cesTypeBoxImg
                  }?size=${cardWidth * 2} 2x`}
                />
              </ImageSection>
              <div className="content">
                <div className="header">{constants.questionMetricTitle.CES}&nbsp;</div>
                <TextDescription className="description">
                  Measure the ease of user experience for specific interaction with your service.
                </TextDescription>
              </div>
            </a>
            <a
              data-testid="template-card-5-star"
              className="ui card"
              onClick={handleOnSelectFiveStar}
            >
              <ImageSection className="image">
                <img
                  className="ui centered image"
                  alt="email-type"
                  style={{ width: cardWidth }}
                  srcSet={`${images.starTypeBoxImg}?size=${cardWidth}, ${
                    images.starTypeBoxImg
                  }?size=${cardWidth * 2} 2x`}
                />
              </ImageSection>
              <div className="content">
                <div className="header">{constants.questionMetricTitle.star}&nbsp;</div>
                <TextDescription className="description">
                  Capture a rating for a product or service.
                </TextDescription>
              </div>
            </a>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  )
}

ChooseSurveyTypeModalV2.propTypes = {
  handleClose: PropTypes.func,
  handleOnSelectNPS: PropTypes.func,
  handleOnSelectCES: PropTypes.func,
  handleOnSelectFiveStar: PropTypes.func,
  isOpenModal: PropTypes.bool,
  handleOnSelectCSAT: PropTypes.func,
  isLoading: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Surveys/ChooseSurveyTypeModalV2/index.js